module.exports = __webpack_public_path__ + "static/media/Transport_for_NSW.8fd92879.png";